import { useCallback, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Icon from "../controls/Icon";
import useNavbar from "../../common/Navbar";
import Nav from 'react-bootstrap/Nav';
import Utils from "../../utils/utils";

const HorizontalNavbar = () => {
    const { objectType } = useParams();
    const [translate] = useTranslation();
    const {
        handleDomainManagementClick,
        handleDeploymentClick,
        handleDrillDownClick,
        selectedTab,
        deployments,
        drillDownObjects,
        next,
        previous,
        hasNextPage,
        currentPage,
        isRootDomain
    } = useNavbar();

    const handleSelect = useCallback((eventId) => {
        switch (eventId) {
            case 'domain-management':
                return handleDomainManagementClick();
            case 'previous-deployment':
                return previous();
            case 'next-deployment':
                return next();
            default: {
                const deployment = deployments.find(({ _id }) => _id === eventId);
                if (deployment) {
                    return handleDeploymentClick(deployment);
                }
                return;
            }
        }
    }, [handleDomainManagementClick, previous, next, deployments, handleDeploymentClick]);

    const header = useMemo(() => {
        const activeKey = typeof selectedTab === 'string' ? selectedTab : selectedTab?._id;

        return (
            <Nav variant='tabs' className='px-3 pt-2' activeKey={activeKey} onSelect={handleSelect}>
                {Utils.isFormsUser() === false && <Nav.Item>
                    <Nav.Link eventKey='domain-management'>
                        {translate('OTM_DOMAIN_MANAGEMENT')}
                    </Nav.Link>
                </Nav.Item>}
                {currentPage !== 1 && <Nav.Item>
                    <Nav.Link className='px-0' eventKey='previous-deployment'>
                        <Icon icon="ChevronLeft" className="d-block" />
                    </Nav.Link>
                </Nav.Item>}
                {deployments.map((deployment) => (
                    <Nav.Item key={deployment._id}>
                        <Nav.Link eventKey={deployment._id}>
                            {deployment.name}
                        </Nav.Link>
                    </Nav.Item>
                ))}
                {hasNextPage && <Nav.Item>
                    <Nav.Link className='px-0' eventKey='next-deployment'>
                        <Icon icon="ChevronRight" className="d-block" />
                    </Nav.Link>
                </Nav.Item>}
            </Nav>
        );
    }, [selectedTab, handleSelect, translate, deployments, hasNextPage, currentPage]);

    const drillDownHeader = useMemo(() => {
        if (!selectedTab) {
            return <></>
        }
        if (Utils.isFormsUser() === true) {
            return <></>
        }
        return (
            <ul className="nav second-level-nav px-3 bg-white">
                {drillDownObjects.map((element, index) => (
                    element.visible &&
                    <li className="nav-item" key={index}>
                        <a href="/"
                            className={`nav-link ${objectType === element.id ? "active" : ""}`}
                            onClick={(event) => { event.preventDefault(); handleDrillDownClick(element.id, selectedTab._id); }}
                        >{element.name}</a>
                    </li>
                ))}
            </ul>
        );
    }, [selectedTab, handleDrillDownClick, drillDownObjects, objectType]);

    return (
        <div className='d-none d-lg-block'>
            {!isRootDomain && header}
            {drillDownHeader}
        </div>
    );
};

export default HorizontalNavbar;